
export { ALLOWED_TRANSPORT_BY_APP } from 'js/config/planner'

// General
export const MODE_DIRECTION = 'direction'
export const MODE_COORDINATES = 'coordinates'
export const LIMIT_SEARCH = 20
export const ORIGIN = 'origin'
export const TIME_FORMAT = 'HH:mm'
export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATETIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`
export const PUBLIC_TRANSPORT_MODE = ['BICYCLE_RENT', 'BUS', 'SUBWAY', 'RAIL'];
export const PRIVATE_TRANSPORT_MODE = ['BICYCLE','CAR' , 'MOTORCYCLE', 'TAXI'];
export const WALKING = 'WALKING'; 
export const PHOTON = 'photon';
export const GOOGLE = 'google';
export const MODES = {
  CAR: 'CAR',
  MOTORCYCLE: 'MOTORCYCLE',
  TAXI: 'TAXI',
  BICYCLE: 'BICYCLE',
  WALK: 'WALK'
}

// transportOptions.js
export const TRANSPORT_OPTIONS = [
    { value: 'BUS', labelKey: 'planner.transports.BUS', icon: 'bus-icon' },
    { value: 'SUBWAY', labelKey: 'planner.transports.SUBWAY', icon: 'subway-icon' },
    { value: 'RAIL', labelKey: 'planner.transports.RAIL', icon: 'rail-icon' },
    { value: 'BICYCLE_RENT', labelKey: 'planner.transports.BICYCLE_RENT', icon: 'bicycle-rent-icon' },
    { value: 'BICYCLE', labelKey: 'planner.transports.BICYCLE', icon: 'bicycle-icon' },
    { value: 'TAXI', labelKey: 'planner.transports.TAXI', icon: 'taxi-icon' },
    { value: 'CAR', labelKey: 'planner.transports.CAR', icon: 'car-icon' },
    { value: 'MOTORCYCLE', labelKey: 'planner.transports.MOTORCYCLE', icon: 'motorcycle-icon' },
    { value: 'WALK', labelKey: 'planner.transports.WALK', icon: 'walk-icon' }
];

// operatorOptions.js
export const OPERATOR_OPTIONS = [
    { id: '3:9', value: 'METROBUS', labelKey: 'planner.operators.metroBus', icon: 'metrobus-icon' },
    { id: '2:EMT', value: 'EMTVALENCIA', labelKey: 'planner.operators.emtValencia', icon: 'emtvalencia-icon' },
    { id: '4:1', value: 'METROVALENCIA', labelKey: 'planner.operators.metroValencia', icon: 'metrovalencia-icon' },
    { id: '1:1071VC', value: 'RENFECERCANIAS', labelKey: 'planner.operators.renfeCercanias', icon: 'renfecercanias-icon' },
    { id: '-', value: 'VALENBISI', labelKey: 'planner.operators.valenBisi', icon: 'valenbici-icon' }
  ];

// timeOptions.js
export const TIME_OPTIONS = [
    { value: '5', label: `${5} planner.time.minutes` },
    { value: '10', label: `${10} planner.time.minutes` },
    { value: '15', label: `${15} planner.time.minutes` },
    { value: '18', label: `${18} planner.time.minutes` },
    { value: '23', label: `${23} planner.time.minutes` },
    { value: '+ 23', label: `+23 planner.time.minutes` }
  ];

  export const OPTIONS_tRANSPORT = {
    publicTransport : ['BUS', 'SUBWAY', 'TRAM', 'RAIL', 'BICYCLE_RENT'],
    privateTransport : ['CAR', 'MOTORCYCLE', 'TAXI'],
    privateBicycle : ['BICYCLE'] // Bicicleta propia
  }  


  // constantes para saber si el icono de los lugares destacados existen

  export const VALID_ICONS = {
    shop: [
      "alcohol",
      "art",
      "bag",
      "bakery",
      "beauty",
      "bed",
      "beverages",
      "bicycle",
      "bookmaker",
      "butcher",
      "car_parts",
      "car_repair",
      "car",
      "carpet",
      "charity",
      "chemist",
      "clothes",
      "coffee",
      "computer",
      "confectionery",
      "convenience",
      "copyshop",
      "dairy",
      "deli",
      "department_store",
      "diy",
      "electronics",
      "fabric",
      "florist",
      "furniture",
      "garden_centre",
      "gift",
      "greengrocer",
      "hairdresser",
      "hearing_aids",
      "hifi",
      "houseware",
      "interior_decoration",
      "jewelry",
      "laundry",
      "marketplace",
      "massage",
      "medical_supply",
      "mobile_phone",
      "motorcycle",
      "music",
      "musical_instrument",
      "newsagent",
      "optician",
      "outdoor",
      "paint",
      "perfumery",
      "pet",
      "photo",
      "seafood",
      "second_hand",
      "shoes",
      "sports",
      "stationery",
      "supermarket",
      "tea",
      "ticket",
      "tobacco",
      "toys",
      "trade",
      "travel_agency",
      "tyres",
      "variety_store",
      "video_games",
      "video"
    ],
    amenity: [
      "advertising_column",
      "aerodrome",
      "arts_centre",
      "atm",
      "bank",
      "bar",
      "bbq",
      "bench",
      "bicycle_parking",
      "bicycle_repair_station",
      "biergarten",
      "boat_rental",
      "bureau_de_change",
      "bus_station",
      "cafe",
      "car_wash",
      "casino",
      "charging_station",
      "cinema",
      "community_centre",
      "courthouse",
      "dentist",
      "doctors",
      "drinking_water",
      "emergency_phone",
      "entrance",
      "excrement_bags",
      "fast_food",
      "ferry",
      "firestation",
      "fountain",
      "fuel",
      "helipad",
      "hospital",
      "hunting_stand",
      "ice_cream",
      "internet_cafe",
      "library",
      "motorcycle_parking",
      "parcel_locker",
      "parking_entrance_multistorey",
      "parking_entrance_underground",
      "parking_subtle",
      "parking_tickets",
      "parking",
      "pharmacy",
      "place_of_worship",
      "police",
      "post_box",
      "post_office",
      "prison",
      "pub",
      "public_bath",
      "public_bookcase",
      "public_transport_tickets",
      "recycling",
      "rental_bicycle",
      "rental_car",
      "restaurant",
      "shelter",
      "shower",
      "social_facility",
      "taxi",
      "telephone",
      "theatre",
      "toilets",
      "town_hall",
      "vehicle_inspection",
      "veterinary",
      "waste_basket",
      "waste_disposal"
    ]
  };
  
